import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirection2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDirection2"><Path d="M12 8.5V3.5H19.5L21.5 6L19.5 8.5H12ZM12 8.5V13.5M12 8.5H4.5L2.5 11L4.5 13.5H12M12 13.5V20.5M12 20.5H8.5M12 20.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDirection2;
